// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qCHb","footer":"styles_footer__27GEI","passCodeTooltip":"styles_passCodeTooltip__1Y5_n"};